module.exports = __webpack_public_path__ + "fonts/Roboto-Black.dd1070ee.ttf";